import api from './api';

export interface LLMKeyInfo {
  provider: string;
  configured: boolean;
  last4: string | null;
}

export const llmKeysService = {
  async list(): Promise<LLMKeyInfo[]> {
    const response = await api.get<{ data: LLMKeyInfo[] }>('/config/llm-keys');
    return response.data.data;
  },
  async setKey(provider: string, apiKey: string): Promise<LLMKeyInfo> {
    const response = await api.put<LLMKeyInfo>(`/config/llm-keys/${provider}`, {
      apiKey,
    });
    return response.data;
  },
  async deleteKey(provider: string): Promise<void> {
    await api.delete(`/config/llm-keys/${provider}`);
  },
};
